export const LINE_CHART_DATA:any[] = [{
  key: `0`,
  values_1: 30
},
{
  key: `1-10 Aug`,
  values_1: 50
},
{
  key: `11-20 Aug`,
  values_1: 27
},
{
  key: `21-30 Aug`,
  values_1: 75
},
{
  key: `1-10 Nov`,
  values_1: 100
}
];

export const BAR_CHART_DATA:any[] = [
  {
    name: 'Investment',
    value: 249542,
    remaining: 458
  },
  {
    name: 'Development',
    value: 50799,
    remaining: 199201
  },
  {
    name: 'Business',
    value: 25567,
    remaining: 224433
  },
  {
    name: 'Design',
    value: 5789,
    remaining: 244211
  }
];